export const theme = {
  global: {
    label: '$reset cursor-pointer text-black dark:text-white formkit-disabled:select-none formkit-disabled:cursor-default',
    help: 'text-sm text-base-700 mb-2 mt-1.5',
    message: 'dark:text-danger-200 mb-1 text-danger-500 text-xs rounded select-none inline-block',
    messages: 'list-none p-0 mt-1 mb-0',
  },
  checkbox: {
    decorator: 'relative cursor-pointer formkit-disabled:cursor-default w-5 h-5 mr-2 flex flex-shrink-0 items-center justify-center transition-colors duration-200 border border-base-300 bg-base-100 dark:bg-base-1000 peer-checked:bg-primary-500 peer-checked:border-primary-500',
    decoratorIcon: 'flex text-2xl opacity-0 formkit-checked:opacity-100 formkit-checked:text-white',
    outer: 'formkit-disabled:opacity-60',
    input: 'fixed left-[999em] w-0 h-0 overflow-hidden opacity-0 pointer-events-none peer',
    wrapper: 'flex items-center mb-1',
  },
  textarea: {
    label: 'font-bold',
    input: 'w-full disabled:bg-base-300 disabled:text-base-700',
    inner: 'shadow-px shadow-secondary-100 focus:shadow-2px focus:shadow-primary-500',
  },
  radio: {
    legend: '$reset font-bold text-black dark:text-white formkit-disabled:select-none',
    decorator: 'relative w-[1.2rem] h-[1.2rem] cursor-pointer formkit-disabled:cursor-default w-5 h-5 rounded-full mr-2 flex flex-shrink-0 items-center justify-center transition-colors duration-200 border border-base-300 bg-base-100 shadow-base-100',
    decoratorIcon: 'transition-all duration-200 rounded-full w-[.6rem] h-[.6rem] formkit-checked:bg-white formkit-checked:shadow-[0_0_0_6px_rgba(0,0,0,1)] formkit-checked:shadow-primary-500',
    outer: 'formkit-disabled:opacity-60',
    input: 'fixed left-[999em] w-0 h-0 overflow-hidden opacity-0 pointer-events-none peer',
    wrapper: 'flex items-center mb-1',
  },
  select: {
    label: 'font-bold',
    inner: 'relative',
    input: 'relative w-full p-2 transition-all duration-200 shadow-px shadow-secondary-100 focus:shadow-2px focus:shadow-primary-500 border-0 appearance-none outline-0 dark:bg-base-1000',
    selectIcon: 'absolute right-[.5rem] top-2/4 -translate-y-1/2',
  },
  'family:text': {
    label: 'font-bold',
    inner: 'flex items-center',
    input: 'relative w-full p-2 transition-all duration-200 shadow-px shadow-secondary-100 focus:shadow-2px focus:shadow-primary-500 border-0 appearance-none outline-0 max-h-10 dark:bg-base-1000 dark:text-white disabled:bg-base-300 disabled:text-base-700',
  },
  'family:date': {
    label: 'font-bold',
    inner: 'flex items-center',
    input: 'relative w-full p-2 transition-all duration-200 shadow-px shadow-secondary-100 focus:shadow-2px focus:shadow-primary-500 border-0 appearance-none outline-0 max-h-10 dark:bg-base-1000 dark:text-white disabled:bg-base-300 disabled:text-base-700',
  },
}

export const themeIcons = {
  icons: {
    checkboxDecorator: '<span class="bi bi-check"></span>',
    radioDecorator: '<span class=""></span>',
    select: '<span class="bi bi-chevron-down"></span>',
  }
}
